export const MAX_AVAILABILITY_PERIODS = 25; // The most availability periods that Cronofy allows
export const START_OF_BUSINESS_HOURS = 9; // 9:00 AM
export const END_OF_BUSINESS_HOURS = 17; // 5:00 PM
